// Developed by Aptus Engineering, Inc. <https://aptusai.com>
// See LICENSE.md file in project root directory

export default (num, min, max) => {

    return num <= min ? min : num >= max ? max : num;

}